import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-800 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-xl text-primary-300 mb-4">韩漫漫画网站</h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                致力于提供完整韩漫大全、优质推荐和流行排行榜。免费下拉式阅读高清内容，无广告干扰，享受纯粹阅读乐趣。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-label font-medium text-background-50 mb-4">分类浏览</h4>
              <div className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-label font-medium text-background-50 mb-4">快捷导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">首页</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-label font-medium text-background-50 mb-4">关注我们</h4>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-50 text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-50 text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-600 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-background-50 text-base"></i>
                </a>
              </div>
              <p className="mt-4 text-xs text-foreground-400">
                联系邮箱：contact@hanmancomic.com
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2026 韩漫漫画网站 版权所有 | 本站内容仅供学习交流使用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer">使用条款</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}